<div class="flex" [ngClass]="{'flex-row': fullSize, 'flex-col': !fullSize}">
  @if(fullSize){
  <div class="p-2">
    <div class="flex-none">
      <div class="flex flex-col text-center shadow rounded-md overflow-hidden">
        <span class="text-xs font-bold text-white bg-red-600 dark:bg-red-700 px-3 py-1">
          {{ activity.date | date: 'MMM' | uppercase }}
        </span>
        <span class="text-lg font-semibold text-gray-900 dark:text-white bg-white dark:bg-gray-700 px-3">
          {{ activity.date | date: 'dd' }}
        </span>
      </div>
    </div>
  </div>

  }@else{
  <div *ngIf="showDate" class="dark:text-white text-xs font-medium mb-2">
    <span>Date: </span> <span>{{activity.date | dateTimeFormat }}</span>
  </div>
  }

  <div class="flex flex-grow flex-col gap-2" [ngClass]="{'mt-2 ml-2 mb-6 mr-4': fullSize}">
    <ng-container [ngSwitch]="activity.type">
      <p *ngSwitchCase="'senateCommunications'" [ngClass]="{'text-md': fullSize, 'text-xs': !fullSize}"
        class="font-medium text-gray-800 pr-2 dark:text-gray-200">
        <b [innerHTML]="activity.detail.number | highlight:searchTerm"></b>:<span
          [innerHTML]="activity.detail.abstract | highlight:searchTerm"></span>
      </p>

      <div *ngSwitchCase="'amendments'">
        <p *ngIf="activity.detail.amendedBill" [ngClass]="{'text-md': fullSize, 'text-xs': !fullSize}"
          class="font-semibold text-gray-800 pr-2 dark:text-gray-200">
          <span class="text-justify" [innerHTML]="activity.detail.amendedBill.title | highlight:searchTerm"></span>
        </p>
        <div *ngIf="activity.detail.description" [ngClass]="{'text-sm': fullSize, 'text-xs': !fullSize}"
          class="text-gray-700 dark:text-gray-300 mt-2"
          [innerHTML]="activity.detail.description | highlight:searchTerm"></div>
        <p *ngIf="activity.detail.purpose" class="text-xs font-light text-gray-800 pr-2 dark:text-gray-200"
          [innerHTML]="activity.detail.purpose | highlight:searchTerm"></p>
      </div>
      <div *ngSwitchCase="'bills'" [ngClass]="{'text-md': fullSize, 'text-xs': !fullSize}"
        class="font-normal text-gray-800 pr-2 dark:text-gray-200 flex flex-col justify-start items-start">

        <span class="text-justify"
          [ngClass]="{'line-clamp-3': !isExpanded && (activity.origin.title.length >= truncAt)}"
          [innerHTML]="activity.origin.title | highlight:searchTerm"></span>
        <button class="text-xs  mb-2 text-blue-500 hover:text-blue-700 transition duration-300 ease-in-out inline-block"
          (click)="toggleExpand()" *ngIf="activity.origin.title.length >= truncAt">
          {{ isExpanded ? 'Read Less' : 'Read More' }}
        </button>

        <div *ngIf="fullSize">
          <div class="text-sm text-gray-300 dark:text-gray-400 mt-4">
            <span class="font-semibold  dark:text-white">Latest Action:</span>
            <br />

            <span class="dark:text-gray-300 text-gray-700 text-sm">{{ activity.origin.latestAction.text }}</span>
            <br />
            <span class="dark:text-white text-xs font-bold">
              <span>{{ activity.origin.latestAction.actionDate | date: 'MMM dd, yyyy' }}</span>
              <span class="ml-2">{{ activity.origin.latestAction.actionTime }}</span>
            </span>
          </div>
        </div>

      </div>
      <p *ngSwitchCase="'summaries'" [ngClass]="{'text-md': fullSize, 'text-xs': !fullSize}"
        class="font-medium text-gray-800 pr-2 dark:text-gray-200"
        [innerHTML]="activity.origin.text | highlight:searchTerm"></p>

      <div *ngSwitchCase="'hearings'" [ngClass]="{'text-md': fullSize, 'text-xs': !fullSize}"
        class="font-medium text-gray-800 pr-2 dark:text-gray-200">
        <b [innerHTML]="activity.detail.libraryOfCongressIdentifier | highlight:searchTerm"></b>:<span class="ml-2"
          [innerHTML]="activity.detail.title | highlight:searchTerm"></span>
        <div *ngIf="activity.detail.purpose" [ngClass]="{'text-md': fullSize, 'text-xs': !fullSize}"
          class=" font-medium text-gray-800 pr-2 dark:text-gray-200"
          [innerHTML]="activity.detail.purpose | highlight:searchTerm"></div>
        <div *ngIf="activity.detail.citation"><b>citation: </b><span
            class="text-blue-500">{{activity.detail.citation}}</span></div>
      </div>
      <div *ngSwitchCase="'committeeMeetings'" [ngClass]="{'text-md': fullSize, 'text-xs': !fullSize}"
        class="font-medium text-gray-800 pr-2 dark:text-gray-200">
        <div class="flex flex-col mb-2">

          <span> <b>Status:</b> <span class="ml-2"
              [innerHTML]="activity.detail.meetingStatus | highlight:searchTerm"></span></span>
        </div>

        <span class="font-light" [innerHTML]="activity.detail.title | highlight:searchTerm"></span>

        <div class="flex flex-col mt-2">
          <span> <b>Location:</b> <span class="ml-2"
              [innerHTML]="activity.detail.location.building | highlight:searchTerm"></span></span>
          <span> <b>Room:</b> <span class="ml-2"
              [innerHTML]="activity.detail.location.room | highlight:searchTerm"></span></span>

        </div>
      </div>
    </ng-container>

    <div class="flex flex-row gap-1 items-center">
      <span class="text-xs text-black font-bold dark:text-gray-400"
        [innerHTML]="activity.chamber | highlight:searchTerm"></span> |
      <span class="font-bold capitalize py-1 text-xs" [style.color]="getTypeColor(activity.type)"
        [innerHTML]="splitCamelCase(activity.type) | highlight:searchTerm"></span>
    </div>
  </div>
  <div id="toolbar" class="flex flex-col gap-2 justify-end mr-1" *ngIf="fullSize">


    <button (click)="remove()" class="btn-square mb-1" *ngIf="boardStage === BoardStage.DRAFT">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6 dark:text-red-500 text-red-600">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
      </svg>
    </button>


  </div>
</div>
